// extracted by mini-css-extract-plugin
export default {"verifiedOld":"verified-badge_verifiedOld__l4eX+","verifiedBlue":"verified-badge_verifiedBlue__7h0gQ","verifiedGovernment":"verified-badge_verifiedGovernment__psJyC"};